import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BattleScreen } from './battle/BattleScreen';
import { getTelegramUser, initTelegramSdk } from './telegram/sdk';

type AppScreen = 'home' | 'battle';

export function App() {
  const { t } = useTranslation();
  const [screen, setScreen] = useState<AppScreen>('home');

  useEffect(() => {
    initTelegramSdk();
  }, []);

  const userName = useMemo(() => {
    const user = getTelegramUser();
    return user?.first_name ?? '';
  }, []);

  if (screen === 'battle') {
    return (
      <main className="app">
        <BattleScreen onBack={() => setScreen('home')} />
      </main>
    );
  }

  return (
    <main className="app">
      <h1>{t('app.title')}</h1>
      <p>{t('app.greeting', { name: userName || t('app.guest') })}</p>
      <p className="muted">{t('app.phase0')}</p>
      <button type="button" className="app__battle-test" onClick={() => setScreen('battle')}>
        {t('app.battleTest')}
      </button>
    </main>
  );
}
